var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M8.25 3.75a.75.75 0 0 0-.75.75v.75h9V4.5a.75.75 0 0 0-.75-.75zM18 5.25V4.5a2.25 2.25 0 0 0-2.25-2.25h-7.5A2.25 2.25 0 0 0 6 4.5v.75H3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h16.5a3 3 0 0 0 3-3V8.25a3 3 0 0 0-3-3zM3.75 6.75a1.5 1.5 0 0 0-1.5 1.5v2.25h19.5V8.25a1.5 1.5 0 0 0-1.5-1.5zm18 5.25h-6v.375a1.125 1.125 0 0 1-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125V12h-6v6.75a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgBriefcase;